(() => {
  function formatNumber(value) {
    return Math.max(0, Math.round(Number(value) || 0)).toLocaleString('en-US');
  }

  function randomInt(min, max) {
    const safeMin = Math.round(Number(min) || 0);
    const safeMax = Math.round(Number(max) || safeMin);
    const from = Math.min(safeMin, safeMax);
    const to = Math.max(safeMin, safeMax);
    return Math.floor(Math.random() * (to - from + 1)) + from;
  }

  function updateCountSoftly(node, nextValue) {
    if (!node) return;

    const nextText = formatNumber(nextValue);
    if (node.textContent === nextText) return;

    node.classList.add('is-changing');

    window.setTimeout(() => {
      node.textContent = nextText;
      node.classList.remove('is-changing');
    }, 180);
  }

  function pickNextVisitorsValue(root, currentValue) {
    const base = Number(root.dataset.viewBase || 0);
    const minDelta = Math.abs(Number(root.dataset.viewMinDelta || 0));
    const maxDelta = Math.max(minDelta, Math.abs(Number(root.dataset.viewMaxDelta || 0)));
    const minValue = Math.max(1, base - maxDelta);
    const maxValue = Math.max(minValue, base + maxDelta);
    const forbiddenValue = Math.max(1, Math.round(Number(currentValue) || base));

    for (let index = 0; index < 8; index += 1) {
      const direction = Math.random() > 0.5 ? 1 : -1;
      const delta = randomInt(minDelta, maxDelta) * direction;
      const nextValue = Math.max(minValue, Math.min(maxValue, base + delta));

      if (nextValue !== forbiddenValue) {
        return nextValue;
      }
    }

    return Math.max(minValue, Math.min(maxValue, forbiddenValue + (forbiddenValue >= maxValue ? -1 : 1)));
  }

  function scheduleVisitorsUpdate(root, countNode) {
    const minDelay = Number(root.dataset.viewIntervalMin || 4);
    const maxDelay = Number(root.dataset.viewIntervalMax || 8);
    const currentValue = Number(countNode.textContent.replace(/,/g, '') || root.dataset.viewBase || 0);
    const nextValue = pickNextVisitorsValue(root, currentValue);

    updateCountSoftly(countNode, nextValue);

    window.setTimeout(() => scheduleVisitorsUpdate(root, countNode), randomInt(minDelay, maxDelay) * 1000);
  }

  function scheduleSoldUpdate(root, countNode) {
    let current = Number(countNode.textContent.replace(/,/g, '') || root.dataset.soldBase || 0);
    const minStep = Number(root.dataset.soldMinStep || 1);
    const maxStep = Number(root.dataset.soldMaxStep || 5);
    const minDelay = Number(root.dataset.soldIntervalMin || 20);
    const maxDelay = Number(root.dataset.soldIntervalMax || 60);

    current += randomInt(minStep, maxStep);
    updateCountSoftly(countNode, current);

    window.setTimeout(() => scheduleSoldUpdate(root, countNode), randomInt(minDelay, maxDelay) * 1000);
  }

  document.querySelectorAll('[data-live-sales-sht]').forEach((root) => {
    const viewNode = root.querySelector('[data-live-sales-view-count]');
    const soldNode = root.querySelector('[data-live-sales-sold-count]');

    if (viewNode) {
      viewNode.textContent = formatNumber(root.dataset.viewBase);
      window.setTimeout(() => scheduleVisitorsUpdate(root, viewNode), 800);
    }

    if (soldNode) {
      soldNode.textContent = formatNumber(root.dataset.soldBase);
      window.setTimeout(() => scheduleSoldUpdate(root, soldNode), randomInt(root.dataset.soldIntervalMin, root.dataset.soldIntervalMax) * 1000);
    }
  });
})();
